import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { withTranslation } from 'react-i18next';

import {
  checkedCurrencySymbol,
  settingCost,
  getPerItemCouponCost,
  returnComma,
  getAddonTitle,
  getAddonPrice,
} from '../../common/Utils';

function renderOpt(otp) {
  if (otp.length === 0) return null;

  const arr = otp.map((item, i) => (
    <div className="checkout-cart-item-option-box" key={shortid.generate()} style={styles.optionBox}>
      <p className="checkout-cart-item-option-key" style={styles.keyTitle}>{item.title}</p>
      <p className="checkout-cart-item-option-value" style={styles.optValue}>{item.context}</p>
    </div>
  ));

  return <div className="checkout-cart-item-options" style={styles.otpContainer}>{arr}</div>;
}

function renderCoupon(data, couponData, i18n) {
  if (!couponData) return null;
  const perCouponCost = getPerItemCouponCost(data, couponData, i18n.language);
  // console.log(perCouponCost);

  if (perCouponCost > 0) {
    const str = `${checkedCurrencySymbol(i18n.language)}${
      i18n.language === 'en'
        ? returnComma((settingCost(i18n.language, data) - perCouponCost).toFixed(2))
        : returnComma(settingCost(i18n.language, data) - perCouponCost)
    }`;
    return str;
  }

  return null;
}

class CheckOutCartItem extends PureComponent {
  render() {
    const { data, i18n, coupon, addonData, t } = this.props;
    const hasAddon = !!(addonData && addonData.addons && addonData.addons.length > 0);
    return (
      <div className="checkout-cart-item-container" style={styles.container(this.props.marginBottom)}>
        <div className="checkout-cart-item-inner" style={styles.innerContainer}>
          <img className="checkout-cart-item-img" alt="" style={styles.img} src={data.uri_pd} />

          <div className="checkout-cart-item-center" style={styles.centerBox}>
            <div className="checkout-cart-item-title-box" style={styles.titleBox}>
              <p className="checkout-cart-item-title" style={styles.title}>{JSON.parse(data.body).title}</p>
              {data.b_custom === 1 ? (
                <u
                  className="checkout-cart-item-view-detail"
                  style={styles.viewDetailText}
                  role="button"
                  tabIndex="-1"
                  onClick={() => this.props.onViewDtail(data)}
                >
                  View Detail
                </u>
              ) : null}
            </div>
            {renderOpt(JSON.parse(data.body).options)}

            {hasAddon && (
              <div style={styles.addonInfoBox}>
                <p style={styles.addonInfoTitle}>{(t && t('addonOptions')) || 'Add-on Options'}</p>
                {addonData.addons.map((addon, idx) => (
                  <div key={idx} style={styles.addonRow}>
                    <span style={styles.addonName}>{getAddonTitle(addon, i18n.language)}</span>
                    <span style={styles.addonPrice}>
                      {checkedCurrencySymbol(i18n.language)}
                      {i18n.language === 'en'
                        ? returnComma(getAddonPrice(addon, i18n.language).toFixed(2))
                        : returnComma(getAddonPrice(addon, i18n.language))}
                    </span>
                  </div>
                ))}
                {addonData.addon_request ? (
                  <div style={styles.addonRequestBox}>
                    <p style={styles.addonRequestTitle}>{(t && t('addonRequest')) || 'Additional Request'}</p>
                    <p style={styles.addonRequestText}>{addonData.addon_request}</p>
                  </div>
                ) : null}
              </div>
            )}
          </div>

          <p className="checkout-cart-item-price" style={styles.cost(93)}>
            {checkedCurrencySymbol(i18n.language)}
            {i18n.language === 'en'
              ? returnComma(settingCost(i18n.language, data).toFixed(2))
              : returnComma(settingCost(i18n.language, data))}
          </p>
          <p className="checkout-cart-item-multiply" style={styles.multiply}>X</p>
          <p className="checkout-cart-item-quantity" style={styles.quantity}>{data.quantity}ea</p>

          <div className="checkout-cart-item-right" style={styles.rightBox}>
            <p
              className="checkout-cart-item-total-cost"
              style={Object.assign(
                styles.cost(0, renderCoupon(data, coupon, i18n)),
                { fontWeight: 'bold', fontSize: 14 },
              )}
            >
              {checkedCurrencySymbol(i18n.language)}
              {i18n.language === 'en'
                ? returnComma((settingCost(i18n.language, data) * data.quantity).toFixed(2))
                : returnComma(settingCost(i18n.language, data) * data.quantity)}
            </p>
            <p className="checkout-cart-item-coupon-cost" style={styles.couponCost}>{renderCoupon(data, coupon, i18n)}</p>
          </div>
        </div>
      </div>
    );
  }
}

CheckOutCartItem.propTypes = {
  marginBottom: PropTypes.number,
  data: PropTypes.object,
  i18n: PropTypes.object,
  onViewDtail: PropTypes.func,
  coupon: PropTypes.object,
  addonData: PropTypes.object,
  t: PropTypes.func,
};

CheckOutCartItem.defaultProps = {
  marginBottom: 20,
  data: {},
  i18n: {},
  onViewDtail: () => {},
  coupon: null,
  addonData: null,
  t: null,
};

const styles = {
  container: marginBottom => ({
    width: '100%',
    minHeight: 120,
    display: 'flex',
    justifyContent: 'center',
    marginBottom,
    backgroundColor: '#fff',
  }),
  innerContainer: {
    width: '100%',
    maxWidth: 948,
    display: 'flex',
    borderBottom: '2px solid rgba(37, 31, 27, 0.12)',
    boxSizing: 'border-box',
    MozBoxSizing: 'border-box',
    WebkitBoxSizing: 'border-box',
    paddingBottom: 22,
  },
  img: {
    width: 98,
    height: 98,
  },
  centerBox: {
    // width: 412,
    width: 360,
    marginLeft: 24,
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 18,
  },
  title: {
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    fontWeight: 600,
    color: '#251f1b',
  },
  viewDetailText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#c77b46',
    lineHeight: 1.14,
    cursor: 'pointer',
    outline: 'none',
  },
  counterBox: {
    display: 'flex',
    alignItems: 'center',
  },
  qtyText: {
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 1.38,
    letterSpacing: 1,
    color: '#251f1b',
    marginRight: 17,
  },
  rightBox: {
    width: 88,
    marginLeft: 95,
  },
  cost: (marginLeft, isCoupon) => ({
    width: 88,
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    letterSpacing: 1,
    textAlign: 'right',
    color: '#251f1b',
    marginLeft,
    textDecoration: isCoupon ? 'line-through' : 'none',
  }),
  trashBox: {
    width: '100%',
    height: 30,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  trash: {
    cursor: 'pointer',
  },
  optionBox: {
    width: 360,
    display: 'flex',
    marginBottom: 4,
    alignItems: 'center',
  },
  keyTitle: {
    width: 220,
    fontFamily: 'Roboto Condensed',
    fontSize: 14,
    color: '#251f1b',
    lineHeight: 1.57,
    opacity: 0.4,
  },
  optValue: {
    width: 140,
    textAlign: 'right',
    fontFamily: 'Roboto Condensed',
    fontSize: 14,
    color: '#251f1b',
    lineHeight: 1.57,
  },
  otpContainer: {
    marginBottom: 24,
  },
  multiply: {
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    letterSpacing: 1,
    color: '#251f1b',
    marginLeft: 20,
  },
  quantity: {
    width: 40,
    textAlign: 'left',
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    letterSpacing: 1,
    color: '#251f1b',
    marginLeft: 8,
  },
  couponCost: {
    width: 88,
    textAlign: 'right',
    color: '#e85454',
    fontSize: 16,
    fontWeight: 'bold',
  },
  addonInfoBox: {
    marginTop: 4,
    marginBottom: 12,
    paddingTop: 8,
    borderTop: '1px dashed rgba(37, 31, 27, 0.18)',
  },
  addonInfoTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: '#251f1b',
    margin: '0 0 8px',
    fontFamily: 'Roboto Condensed',
    letterSpacing: 0.3,
  },
  addonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
    width: 360,
  },
  addonName: {
    fontSize: 13,
    color: '#251f1b',
    fontFamily: 'Roboto Condensed',
    opacity: 0.85,
  },
  addonPrice: {
    fontSize: 13,
    color: '#d32f2f',
    fontFamily: 'Roboto Condensed',
    fontWeight: 600,
    textAlign: 'right',
  },
  addonRequestBox: {
    marginTop: 8,
    width: 360,
  },
  addonRequestTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: '#251f1b',
    margin: '0 0 4px',
    opacity: 0.7,
  },
  addonRequestText: {
    fontSize: 12,
    color: '#251f1b',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.4,
  },
};

export default withTranslation('translations')(CheckOutCartItem);
